<template>
  <el-select
    :clearable="clearable"
    :disabled="disabled"
    filterable
    :value="value"
    @change="changeHandle"
  >
    <el-option
      v-for="(item, index) in areaServiceList"
      :disabled="disabledValue(item.serviceId)"
      :key="index"
      :value="item.serviceId"
      :label="item.serviceName"
    ></el-option>
  </el-select>
</template>

<script>
import areaServiceMixin from './mixin.js';

export default {
  name: 'area-service-select',
  props: {
    value: {
      type: Number,
      default: null,
    },
    disabled: Boolean,
    clearable: {
      type: Boolean,
      default: true,
    },
    filterList: {
      type: Array,
    },
  },
  mixins: [areaServiceMixin],
  methods: {
    changeHandle(val) {
      if (val || val === 0) {
        this.$emit('input', val);
        this.$emit('change', val);
      } else {
        this.$emit('input', null);
        this.$emit('change', null);
      }
    },
    disabledValue(val) {
      if (this.filterList && this.filterList.length) {
        return this.filterList.indexOf(val) > -1;
      }
      return false;
    },
  },
};
</script>

